import React from 'react';
import './main.less';

import { Link } from 'react-router';
import { connect } from 'react-redux';

import { actions, selectors } from './';

import Table from '../../../shared/new-table/main';
import { renderDefaultTD } from '../../../shared/new-table/renderers';
import table from './table-initial-data';

import wrapMain from '../../wrap-main';
import withCheckPermission from '../../../shared/check-permission-hoc';
import { enum as permissions } from '../../../../../../../enums/admin-permissions';

function createRenderTD(check, removeById) {
	return function ({ index, column }, props) {
		if (index === 'actions') {
			return (
				<td className={column.className} key={index}>
					<div className='goods-actions'>
						{check(permissions.goodsUpdate) && (
							<Link
								className='banners-edit-icon'
								to={`/goods/categories/${props.row.id}/editor`}
							/>
						)}
						{check(permissions.goodsDelete) && !props.row.is_default && (
							<a
								className='goods-remove-icon'
								onClick={() => removeById(props.row.id)}
							/>
						)}
					</div>
				</td>
			);
		}

		return renderDefaultTD({ index, column }, props);
	};
}

function GoodsCategoryList({ intl, rows, check, removeById }) {
	return (
		<div>
			{check(permissions.goodsCreate) && (
				<div className='goods-navigation'>
					<Link
						className='ui-btn ui-btn-primary'
						to='/goods/categories/editor'
					>
						{intl('Create goods category')}
					</Link>
				</div>
			)}
			<Table
				className='goods-table'
				table={table}
				rows={rows}
				renderTD={createRenderTD(check, removeById)}
			/>
		</div>
	);
}

function mapStateToProps(state) {
	return {
		rows: selectors.select(state, 'data'),
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError')
	};
}

export default connect(mapStateToProps, actions.own)(wrapMain(withCheckPermission(GoodsCategoryList)));


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/goods/category/list/main.js